export default __webpack_public_path__ + "static/media/markenbekanntheit.362ee48a.jpg";